module.exports = __webpack_public_path__ + "static/media/thum_2.d64400d5.jpg";